export var Protocols;
(function (Protocols) {
    Protocols["HTTP"] = "http";
    Protocols["HTTPS"] = "https";
})(Protocols || (Protocols = {}));
